import type { FeatureFlag } from '@/graphql/gql-types';
import { useState } from 'react';
import { useGetFeatureFlagsQuery } from '../gql/_gen_/feature-flags.gql';

export const useFeatureFlags = () => {
	const { loading, refetch } = useGetFeatureFlagsQuery({
		onCompleted(data) {
			setFlags(data.getFeatureFlags);
		},
	});
	const [flags, setFlags] = useState<FeatureFlag>();

	return { flags, loading, refetch };
};
